<template>
  <div class="json-viewer">
    <pre v-html="highlightedJson" />
  </div>
</template>

<script lang="ts">

export default {
  name: 'JsonViewer',
  props: {
    json: {
      type: [String, Object, Array],
      required: true,
    },
  },
  computed: {
    highlightedJson() {
      return this.syntaxHighlight(this.json)
    },
  },
  methods: {
    syntaxHighlight(json) {
      let stringified = JSON.stringify(json)

      if (stringified.length > 50) {
        stringified = JSON.stringify(json, null, 2)
      }

      return stringified.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\\-]?\d+)?)/g,
        match => {
          let cls = 'number'
          if (/^"/.test(match)) {
            if (/:$/.test(match)) {
              cls = 'key'
            } else {
              cls = 'string'
            }
          } else if (/true|false/.test(match)) {
            cls = 'boolean'
          } else if (/null/.test(match)) {
            cls = 'null'
          }
          return `<span class="${cls}">${match}</span>`
        },
      )
    },
  },

}
</script>

<style>
  /* .json-viewer {
    background-color: #f4f4f4;
    border-radius: 4px;
    padding: 1rem;
    border-radius: 0.75rem;
  } */
  pre {
    background-color: transparent;
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .string {
    color: #008000;
  }
  .number {
    color: #0000ff;
  }
  .boolean {
    color: #b22222;
  }
  .null {
    color: #808080;
  }
  .key {
    color: #a52a2a;
  }
</style>
